var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFireBehaviourIndex = function SvgFireBehaviourIndex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.53 9.377c-2.03-2.03-4.653-3.13-7.53-3.13s-5.5 1.1-7.53 3.13-3.131 4.654-3.131 7.53c0 .508.338.847.846.847h19.63c.508 0 .847-.339.847-.846 0-2.877-1.1-5.5-3.131-7.531m-6.684 5.5V7.938c1.777.17 3.47.847 4.908 2.031zm-1.692 0-3.385-3.385L6.246 9.97c1.439-1.1 3.131-1.861 4.908-2.03zM3.03 16.06a9 9 0 0 1 2.03-4.907L9.97 16.06zm11 0 2.03-2.03 2.878-2.877c1.184 1.354 1.861 3.046 2.03 4.907z"
  })));
};
export default SvgFireBehaviourIndex;